import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Document\MigrateLibraryDocumentToDocumentLocalController::__invoke
* @see app/Http/Controllers/Document/MigrateLibraryDocumentToDocumentLocalController.php
* @route '/api/document/{document}/copy-library-to-local'
*/
const MigrateLibraryDocumentToDocumentLocalController = (args: { document: string | number | { id: string | number } } | [document: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: MigrateLibraryDocumentToDocumentLocalController.url(args, options),
    method: 'put',
})

MigrateLibraryDocumentToDocumentLocalController.definition = {
    methods: ["put"],
    url: '/api/document/{document}/copy-library-to-local',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Document\MigrateLibraryDocumentToDocumentLocalController::__invoke
* @see app/Http/Controllers/Document/MigrateLibraryDocumentToDocumentLocalController.php
* @route '/api/document/{document}/copy-library-to-local'
*/
MigrateLibraryDocumentToDocumentLocalController.url = (args: { document: string | number | { id: string | number } } | [document: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { document: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { document: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            document: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        document: typeof args.document === 'object'
        ? args.document.id
        : args.document,
    }

    return MigrateLibraryDocumentToDocumentLocalController.definition.url
            .replace('{document}', parsedArgs.document.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Document\MigrateLibraryDocumentToDocumentLocalController::__invoke
* @see app/Http/Controllers/Document/MigrateLibraryDocumentToDocumentLocalController.php
* @route '/api/document/{document}/copy-library-to-local'
*/
MigrateLibraryDocumentToDocumentLocalController.put = (args: { document: string | number | { id: string | number } } | [document: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: MigrateLibraryDocumentToDocumentLocalController.url(args, options),
    method: 'put',
})

export default MigrateLibraryDocumentToDocumentLocalController